import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-21f8caf0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "statistical-continue-page" }
const _hoisted_2 = { class: "statistical-continue-page__consumer" }

import { computed, onMounted, ref } from 'vue'
import dayjs from 'dayjs'
import { ElMessage } from 'element-plus'
import { CrudSearch, CrudTable } from '@/components/crud-v2'
import { usePagedCrud } from '@/hooks/crud/usePagedCrud'
import { usePermission } from '@/hooks/usePermission'
import { useStore } from '@/store'
import type { CrudSelectOption } from '@/types/crud-config'
import {
  createStatisticalContinueSearchItems,
  statisticalContinueTableColumns
} from './statistical-continue.config'
import {
  fetchStatisticalContinueFilterOptions,
  fetchStatisticalContinuePage
} from './statistical-continue.service'


export default /*#__PURE__*/_defineComponent({
  __name: 'StatisticalContinue',
  setup(__props) {

const store = useStore()
const userInfo = store.state.login.userInfo
const isManager = String(userInfo.isManager) === '1'
const canList = usePermission('liveStatisticalContinue', 'list')

const createFilters = () => ({
  channelId: '',
  accessTime: [
    dayjs().subtract(1, 'weeks').startOf('date').format('YYYY-MM-DD HH:mm:ss'),
    dayjs().endOf('date').format('YYYY-MM-DD HH:mm:ss')
  ],
  continueAttend: '',
  deptId: isManager ? userInfo.deptId : '',
  empIds: isManager ? '' : userInfo.id
})

const {
  filters,
  pageNo,
  pageSize,
  records,
  total,
  error,
  loading,
  load,
  search,
  reset,
  changePage,
  changePageSize,
  refresh
} = usePagedCrud({
  createFilters,
  fetchPage: fetchStatisticalContinuePage
})

const optionsLoading = ref(false)
const channelOptions = ref<CrudSelectOption[]>([])
const employeeOptions = ref<CrudSelectOption[]>([])
const departmentOptions: CrudSelectOption[] = store.state.login.depts.map(
  (item: { id: string | number; name: string }) => ({
    label: item.name,
    value: item.id
  })
)

const searchItems = computed(() =>
  createStatisticalContinueSearchItems({
    channelOptions: channelOptions.value,
    departmentOptions,
    employeeOptions: employeeOptions.value,
    isManager,
    optionsLoading: optionsLoading.value
  })
)
const errorMessage = computed(() =>
  error.value instanceof Error ? error.value.message : ''
)

async function loadFilterOptions() {
  optionsLoading.value = true
  try {
    const options = await fetchStatisticalContinueFilterOptions()
    channelOptions.value = options.channels.map((item) => ({
      label: item.eventName,
      value: item.rowId
    }))
    employeeOptions.value = options.employees.map((item) => ({
      label: item.realName,
      value: item.id
    }))
  } catch (cause) {
    ElMessage.error(
      cause instanceof Error ? cause.message : '筛选项加载失败，请稍后重试'
    )
  } finally {
    optionsLoading.value = false
  }
}

onMounted(() => {
  loadFilterOptions()
  if (canList) load()
})

return (_ctx: any,_cache: any) => {
  const _component_el_avatar = _resolveComponent("el-avatar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(CrudSearch), {
      model: _unref(filters),
      items: searchItems.value,
      loading: _unref(loading),
      onSearch: _unref(search),
      onReset: _unref(reset)
    }, null, 8, ["model", "items", "loading", "onSearch", "onReset"]),
    _createVNode(_unref(CrudTable), {
      rows: _unref(records),
      "page-no": _unref(pageNo),
      "page-size": _unref(pageSize),
      total: _unref(total),
      loading: _unref(loading),
      "error-message": errorMessage.value,
      columns: _unref(statisticalContinueTableColumns),
      onPageChange: _unref(changePage),
      onPageSizeChange: _unref(changePageSize),
      onRetry: _unref(refresh)
    }, {
      title: _withCtx(() => [
        _createTextVNode("持续访问记录")
      ]),
      consumer: _withCtx(({ row }) => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_el_avatar, {
            shape: "square",
            size: 60,
            src: row.consumerHeadImgUrl
          }, null, 8, ["src"]),
          _createElementVNode("span", null, _toDisplayString(row.consumerNickName), 1)
        ])
      ]),
      _: 1
    }, 8, ["rows", "page-no", "page-size", "total", "loading", "error-message", "columns", "onPageChange", "onPageSizeChange", "onRetry"])
  ]))
}
}

})